import React, { Component, PropTypes } from 'react';
import Pagination from 'react-js-pagination';
import styleable from 'react-styleable';
import defaultStyle from './paged-list.style';

export class PagingControl extends Component {

  render() {
    const { currentPage, resultsPerPage, variableResultsPerPage, perPageOptions,
      totalItemsCount, changePageNumber, changeResultsPerPage, css } = this.props;

    return(
      <div className={css.pagingControls}>
          {resultsPerPage < totalItemsCount ?
            <div className={css.pagination}>
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={resultsPerPage}
                totalItemsCount={totalItemsCount}
                pageRangeDisplayed={10}
                firstPageText={"First"}
                prevPageText={"Previous"}
                nextPageText={"Next"}
                lastPageText={"Last"}
                onChange={(page) => changePageNumber(page)}
              />
            </div>
            : null}
          {variableResultsPerPage ? (
            <span className={css.perPage}>
              <select
                id={'per-page-dropdown'}
                className={css.dropdown}
                value={resultsPerPage.toString()}
                aria-label='Items Per Page'
                onChange={e => changeResultsPerPage(e.target.value)}>
                {perPageOptions && perPageOptions.map( (option, index) =>
                  <option key={index} value={option.value}>{option.label}</option>)}
              </select>
              <label htmlFor='per-page-dropdown'>Items Per Page</label>
            </span>) : null }
        </div>
    );
  }
}

PagingControl.propTypes = {
  resultsPerPage: PropTypes.number.isRequired,
  totalItemsCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  variableResultsPerPage: PropTypes.bool.isRequired,
  perPageOptions: PropTypes.array,    // expects an array with objects containing a number 'value' and a string 'label'
  changeResultsPerPage: PropTypes.func.isRequired,
  changePageNumber: PropTypes.func.isRequired,
}

export default styleable(defaultStyle) (PagingControl);



// WEBPACK FOOTER //
// src/common/paging-control.js